import { QuestionsMode } from "../types";
import QuestionsPage from "./questions/QuestionsPage";
export default function QuestionsRoute() {
  const mode: QuestionsMode = { kind: "generic" };
  return <QuestionsPage mode={mode} />;
}
